/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dollar': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M7.8 4.5h7.7V2.3h-4.4V.1H8.9v2.2H7.8C6 2.3 4.5 3.8 4.5 5.6v2.2c0 1.8 1.5 3.3 3.3 3.3h4.4c.6 0 1.1.5 1.1 1.1v2.2c0 .6-.5 1.1-1.1 1.1H4.5v2.2h4.4v2.2h2.2v-2.2h1.1c1.8 0 3.3-1.5 3.3-3.3v-2.2c0-1.8-1.5-3.3-3.3-3.3H7.8c-.6 0-1.1-.5-1.1-1.1V5.6c0-.6.5-1.1 1.1-1.1z"/>'
  }
})
